import { useEffect, useState } from 'react'

const useViewPortWidth = () => {
    const [viewPortWidth, setViewPortWidth] = useState<number>(0)

    useEffect(() => {
        const handleResize = () => {
            setViewPortWidth(window.innerWidth)
        }
        
        // Set initial width
        if (typeof window !== 'undefined') {
            setViewPortWidth(window.innerWidth)
            window.addEventListener('resize', handleResize)
            
            // Also listen for orientation changes on mobile
            window.addEventListener('orientationchange', () => {
                // Small delay to ensure the viewport has updated
                setTimeout(handleResize, 100)
            })
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize)
                window.removeEventListener('orientationchange', handleResize)
            }
        }
    }, [])

    return { viewPortWidth, setViewPortWidth }
}

export default useViewPortWidth